export default function ArkFooter() {
  return (
    <footer
      data-testid="ark-footer"
      className="mt-24 border-t border-[var(--ark-border)] bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <div className="font-display font-bold text-2xl tracking-tight">
            ARK
          </div>
          <p className="text-sm text-[var(--ark-muted)] mt-1 max-w-md">
            Old Wood, New Life. Finished Your Way. Canadian-made, lovingly
            restored.
          </p>
        </div>
        <div className="flex items-center gap-6 text-[0.72rem] uppercase tracking-[0.18em] text-[var(--ark-muted)]">
          <a
            href="https://www.arkfurniture.ca/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[var(--ark-accent)] transition-colors"
          >
            arkfurniture.ca
          </a>
          <span className="text-[var(--ark-border)]">/</span>
          <span>© {new Date().getFullYear()} ARK</span>
        </div>
      </div>
    </footer>
  );
}
